<template>
<div>
    <button :class="[{'is-active': is_open}, 'hamburger', 'hamburger--spin-r',]" type="button" @click="burgerSwitch">
      <span class="hamburger-box">
        <span class="hamburger-inner"></span>
      </span>
    </button>
</div>
</template>

<script>
//import Social from "@/components/atoms/Social.vue";
export default {
    components: {
        //Social,
    },
    data() {
        return {
            is_open: false,
            socials: [
                {
                    icon: "fab fa-facebook",
                    link: "https://www.facebook.com",
                },
                {
                    icon: "fab fa-youtube",
                    link: "https://www.instagram.com",
                },
                {
                    icon: "fab fa-twitter",
                    link: "https://wwww.twitter.com",
                },
            ]
        }
    },
    methods: {
        burgerSwitch() {
            this.is_open = !this.is_open
            this.$emit('click');
        }
    }
}
</script>

<style lang="scss">

button:hover {
    border: none !important;
}

.is-active {
    border: none !important;
}


</style>